export default "__VITE_ASSET__bami7ZWz__"